
bq.paymentMethodData = function(element, options) {
    this.options  = options;
    this.$element = $(element);
    this.control  = {ls:false, la:false, rs:false, ra:false};
};

bq.paymentMethodData.DEFAULTS = {
    input: 'input.payment-method-data',
    left: {},
    right: {},
    escapeMarkup: function(m) { return m; },
};

bq.paymentMethodData.prototype = {
    init: function() {
        bq.debug.log("Payment Method Data : init()", this.$element);

        this.control.ls = $('#' + this.options.controlLs);
        this.control.la = $('#' + this.options.controlLa);
        this.control.rs = $('#' + this.options.controlRs);
        this.control.ra = $('#' + this.options.controlRa);
        this.left = this.$element.find('select.multiselect').eq(0);
        this.right = this.$element.find('select.multiselect').eq(1);

        this.create();
    },

    create: function() {
        var $options = {
            right: '#' + this.right.attr('id'),
            rightAll: '#' + this.control.ra.attr('id'),
            rightSelected: '#' + this.control.rs.attr('id'),
            leftSelected: '#' + this.control.ls.attr('id'),
            leftAll: '#' + this.control.la.attr('id'),
            afterMoveToRight: this.changeHandler.bind(this),
            afterMoveToLeft: this.changeHandler.bind(this),
            sort: function(a, b) {
                return (a.innerHTML.toLowerCase() > b.innerHTML.toLowerCase()) ? 1 : -1;
            }
        };

        this.left.multiselect($options);
    },

    input: function() {
        if (typeof (this._input) == 'undefined') {
            this._input = this.$element.find(this.options.input);
        }
        return this._input;
    },

    changeHandler: function(left, right, selected) {
        this.invertValuesHandler(right);
    },

    invertValuesHandler: function(elem) {
        var selectedIds = $('#' + elem.attr('id') + ' option').map(function() {return $(this).val();}).get();
        this.input().val(selectedIds)
    },

};

// PAYMENT METHOD DATA PLUGIN DEFINITION
// =======================

var paymentMethodDataOld = $.fn.paymentMethodData;

$.fn.paymentMethodData = function (option, _relatedTarget) {
    return this.each(function () {
        var $this   = $(this);
        var data    = $this.data('bq.paymentMethodData');
        var options = $.extend({}, bq.paymentMethodData.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

        if (!data) { $this.data('bq.paymentMethodData', (data = new bq.paymentMethodData(this, options))); }
        data.init();
    });
};

$.fn.paymentMethodData.Constructor = bq.paymentMethodData;

// PAYMENT METHOD DATA NO CONFLICT
// =================

$.fn.paymentMethodData.noConflict = function () {
    $.fn.paymentMethodData = paymentMethodDataOld;
    return this;
};

// PAYMENT METHOD DATA DATA-API
// ==============

bq.paymentMethodDataInit = function() {
    $('[data-bq="payment-method-data"]').each(function () {
        var el = $(this);
        if(el.data('bq.paymentMethodData')) { return; }
        el.paymentMethodData(el.data());
    });
};

bq.init.push(bq.paymentMethodDataInit);